import React from "react";
import styled from "styled-components";

import firebase from "../firebase.client";
import ConnectButton from "./ConnectButton";
import Link from "./Link";

/**
 *  Like Facebook when hovering over a user name,
 *  when doing that a little section appears with
 *  the user/entity information.
 *
 *
 *
 *  Resources:
 *  - https://stackoverflow.com/q/8566090
 *  - https://stackoverflow.com/q/29568721
 */
export default function PreviewHover(props) {
  const ref = React.useRef();
  const [position, setPosition] = React.useState({});
  const [userData, setUserData] = React.useState({});
  React.useEffect(onMountUpdate, []);

  return (
    <S.RelativeContainer>
      {React.cloneElement(props.children, { ref })}
      <S.AbsoluteContainer top={position.top} bottom={position.bottom}>
        {getPreviewContent()}
      </S.AbsoluteContainer>
    </S.RelativeContainer>
  );

  async function onMountUpdate() {
    const currHeight = ref.current.offsetHeight;
    setPosition({ top: currHeight });

    const firebaseUserData = (
      await firebase.firestore().collection("users").doc(props.id).get()
    ).data();
    setUserData(firebaseUserData);
  }

  function getPreviewContent() {
    if (props.type === "actor") {
      return (
        <>
          <S.TopContainer>
            <S.InfoContainer>
              <S.TextBold>
                <Link
                  href={`/member/${props.id}`}
                >{`${props.firstName} ${props.lastName}`}</Link>
              </S.TextBold>
              <S.TextGrey>
                {[userData?.jobTitle, userData?.jobCompany]
                  .filter(Boolean)
                  .join(" • ")}
              </S.TextGrey>
              <S.TextGrey>
                {[userData?.city, userData?.country].filter(Boolean).join(", ")}
              </S.TextGrey>
            </S.InfoContainer>
          </S.TopContainer>
          {userData?.bio && (
            <S.MediumContainer>
              <S.TextGrey>
                {userData?.bio.length > 100
                  ? `${userData?.bio?.slice(0, 100)} ...`
                  : `${userData?.bio}`}
              </S.TextGrey>
            </S.MediumContainer>
          )}
          <S.ActionContainer>
            <ConnectButton id={props.id} name={props.name} size="sml" />
          </S.ActionContainer>
        </>
      );
    }

    return null;
  }
}

const S = {};

S.AbsoluteContainer = styled.div`
  visibility: hidden;
  transition: 0s visibility;
  position: absolute;
  ${(props) => (props.top ? `top: ${props.top}px;` : ``)}
  left: 50%;
  min-width: 280px;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.5) 0px 0px 0px 1px inset;
  background: white;
  border-radius: 10px;
  z-index: 10;
  padding: 10px;
`;

S.RelativeContainer = styled.div`
  position: relative;
  display: inline-block;
  :hover {
    & > ${S.AbsoluteContainer} {
      visibility: visible;
      transition-delay: 0.3s;
    }
  }
`;

S.TopContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 10px;
`;

S.MediumContainer = styled.div`
  padding-bottom: 10px;
`;

S.ActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

S.Image = styled.img`
  object-fit: cover;
  object-position: 50% 50%;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background: rgb(243, 196, 150);
  margin-right: 10px;
`;

S.GroupImage = styled.img`
  object-fit: cover;
  object-position: 50% 50%;
  width: 120px;
  height: 120px;
  border-radius: 20px;
  background: rgb(243, 196, 150);
  margin-right: 10px;
`;

S.InfoContainer = styled.div`
  margin-left: 10px;
`;

S.TextBold = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: rgb(5, 5, 5);
  line-height: 20px;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

S.TextGrey = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: rgb(101, 103, 107);
  line-height: 18px;
`;

S.SquareContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 5px;
  width: 40px;
  height: 35px;
  border-radius: 5px;
  background-color: rgb(228, 230, 235);
  :hover {
    cursor: pointer;
    background: rgb(255, 125, 0);
    path {
      fill: white;
    }
  }
`;

S.Space = styled.div`
  height: 10px;
`;
